import type { Avatar } from '@jotta/types/Avatar'
import type { Avatar as AvatarPB } from '@jotta/grpc-connect-openapi/avatar'
import type { PartialMessage } from '@bufbuild/protobuf'

export function avatarFromProtobuf(avatar?: PartialMessage<AvatarPB>): Avatar {
  const initials = avatar?.initials || ''
  const backgroundColor = avatar?.backgroundColor

  return {
    initials: initials,
    backgroundColor: backgroundColor
      ? `rgb(${backgroundColor.r}, ${backgroundColor.g}, ${backgroundColor.b})`
      : '',
    profilePhotoUrl: avatar?.profilePhotoUrl,
  }
}
